<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from '@/utils/uiWrapper'
import FooterViewOld from './Old/OldXSLFileDIfference.vue'
import NewFooterView from './New/NewXSLFileDIfference.vue'

const current = useUiWrapper(FooterViewOld, NewFooterView)
</script>
